import { FaUpload } from "react-icons/fa";
import { MdTextsms, MdFolder } from "react-icons/md";
import { MdWhatsapp } from "react-icons/md";
import {
    Logout,
    EmailSharp,
    ScheduleSharp,
    Queue,
    Analytics,
    Message,
    Speed,
    AlternateEmail,
    Dns,
    People,
    LockReset,
    AdminPanelSettings,
    AccountBalanceWallet,
    ReceiptLong,
    Payments,
    Campaign,
    BarChart,
    Group,
    AddCircleOutline,
    InsertDriveFile,
    Description,
    DashboardCustomize,
    ManageSearch,
    Send,
    Chat,
    SmartToy,
    Dashboard as DashboardIcon,
    TrendingUp,
    Contacts as ContactsIcon,
    Timeline,
    LeaderboardOutlined,
    ViewColumn,
    Inventory2Outlined,
    LocalOfferOutlined,
    Settings,
} from "@mui/icons-material";
import SendSharpIcon from "@mui/icons-material/SendSharp";

/**
 * Primary items with optional children (secondary).
 * roleCheck: function(userRolesArray) => boolean
 * childFilter: function(child, userRolesArray) => boolean - optional, filters children
 * action: 'navigate' | 'logout' - for items without children
 * openInNewTab: boolean - for specific child links
 */
export const PRIMARY_ITEMS = [
    {
        id: "dashboard",
        name: "Dashboard",
        icon: <DashboardIcon sx={{ fontSize: 24 }} />,
        path: "/dashboard",
        roles: null,
    },
    {
        id: "view-templates",
        name: "View Templates",
        icon: <MdFolder size={24} />,
        roles: ["TEMPLATE"],
        child: [
            { path: "/template-type1", name: "Watermark Templates", icon: <InsertDriveFile fontSize="small" /> },
            { path: "/template-type2", name: "Without Watermark Templates", icon: <Description fontSize="small" /> },
        ],
    },
    {
        id: "personal-whatsapp",
        name: "Personal WhatsApp",
        icon: <SendSharpIcon sx={{ fontSize: 24 }} />,
        roles: ["PERSONAL"],
        child: [
            { path: "/personal-whatsapp", name: "WhatsApp Campaign", icon: <Campaign fontSize="small" /> },
            { path: "/message-queue", name: "Message Queue", icon: <Queue fontSize="small" /> },
            { path: "/whatsapp/message-speed", name: "Message Speed", icon: <Speed fontSize="small" /> },
            { path: "/group-add", name: "Manage Groups", icon: <Group fontSize="small" /> },
            { path: "/create-template", name: "Create Template", icon: <AddCircleOutline fontSize="small" /> },
            { path: "/personal/whatsapp/report", name: "Personal WhatsApp Analytics", icon: <BarChart fontSize="small" /> },
        ],
    },
    {
        id: "email",
        name: "Business Email",
        icon: <EmailSharp sx={{ fontSize: 24 }} />,
        roles: ["EMAIL", "EMAIL-USER", "EMAIL-AGENT"],
        child: [
            { path: "/email-schedule", name: "Email Campaign", icon: <ScheduleSharp fontSize="small" /> },
            // { path: "/email/templates", name: "Create Email Templates", icon: <Message fontSize="small" /> },
            { path: "/email/templateList", name: "Create Email Templates", icon: <Message fontSize="small" /> },
            { path: "/email-queue", name: "Email Queue", icon: <Queue fontSize="small" /> },
            { path: "/email/message-speed", name: "Message Speed", icon: <Speed fontSize="small" /> },
            { path: "/email-analytics", name: "Email Analytics", icon: <Analytics fontSize="small" /> },
            { path: "/email/manageemailsenders", name: "Sender Email", icon: <AlternateEmail fontSize="small" /> },
            { path: "/email/managedomains", name: "Domain Email", icon: <Dns fontSize="small" /> },
        ],
    },
    {
        id: "whatsapp-business",
        name: "WhatsApp Business",
        icon: <MdWhatsapp size={24} />,
        roles: ["WB-ADMIN", "WB-USER"],
        child: [
            { path: "/whatsapp-business/templates", name: "Templates", icon: <DashboardCustomize fontSize="small" /> },
            { path: "/whatsapp-business/campaign", name: "Create Campaign", icon: <Campaign fontSize="small" /> },
            { path: "/whatsapp-business/campaign-management", name: "Campaign Management", icon: <ManageSearch fontSize="small" /> },
            { path: "/whatsapp-business/test-message", name: "Test Message", icon: <Send fontSize="small" /> },
            { path: "/whatsapp-business/message-speed", name: "Message Speed", icon: <Speed fontSize="small" /> },
            { path: "/whatsapp-business/groups", name: "Manage Groups", icon: <Group fontSize="small" /> },
            { path: "/whatsapp-business/contacts", name: "Contacts", icon: <People fontSize="small" /> },
            { path: "/whatsapp-business/message-queue", name: "Message Queue", icon: <Queue fontSize="small" /> },
            { path: "/whatsapp-business/chat-window", name: "Chat", icon: <Chat fontSize="small" /> },
            { path: "/whatsapp-business/bot-training", name: "AI Agent", icon: <SmartToy fontSize="small" /> },
            { path: "/whatsapp-business/settings", name: "Whatsapp Business Settings", icon: <Settings fontSize="small" /> },
        ],
        childFilter: (child, userRolesArray) => {
            if (child.path === "/whatsapp-business/chat-window") return userRolesArray.includes("WB-CHAT");
            if (child.path === "/whatsapp-business/bot-training") return userRolesArray.includes("WB-AGENT");
            if (child.path === "/whatsapp-business/settings") return userRolesArray.includes("WB-ADMIN");
            return true;
        },
    },
    {
        id: "crm",
        name: "CRM",
        icon: <LeaderboardOutlined sx={{ fontSize: 24 }} />,
        roles: ["CRM-ADMIN", "CRM-USER"],
        child: [
            { path: "/crm/dashboard", name: "Dashboard",    icon: <DashboardIcon fontSize="small" /> },
            { path: "/crm/analytics", name: "Analytics",    icon: <Analytics fontSize="small" /> },
            { path: "/crm/pipeline",  name: "Deals",        icon: <TrendingUp fontSize="small" /> },
            { path: "/crm/stages",    name: "Manage stages", icon: <ViewColumn fontSize="small" /> },
            { path: "/crm/tags",      name: "Create Tags",   icon: <LocalOfferOutlined fontSize="small" /> },
            { path: "/crm/contacts",  name: "Contacts",     icon: <ContactsIcon fontSize="small" /> },
            { path: "/crm/tasks",  name: "Tasks", icon: <Timeline fontSize="small" /> },
            { path: "/crm/products-services", name: "Products / Services", icon: <Inventory2Outlined fontSize="small" /> },
        ],
        childFilter: (child, userRolesArray) => {
            if (child.path === "/crm/stages" || child.path === "/crm/tags") return userRolesArray.includes("CRM-ADMIN");
            return true;
        },
    },
    {
        id: "upload",
        name: "Upload & Share",
        icon: <FaUpload size={24} />,
        path: "/upload",
        roles: ["TEMPLATE"],
    },
    {
        id: "message",
        name: "Message",
        icon: <MdTextsms size={24} />,
        path: "/",
        roles: ["MESSAGE"],
    },
    {
        id: "send-whatsapp",
        name: "Send WhatsApp",
        icon: <MdWhatsapp size={24} />,
        path: "/send-whatsapp",
        roles: ["COMMERCIAL"],
    },
    {
        id: "credits-info",
        name: "Credits Information",
        icon: <AccountBalanceWallet sx={{ fontSize: 24 }} />,
        path: "/credits-info",
        roles: null,
    },
    {
        id: "change-password",
        name: "Change Password",
        icon: <LockReset sx={{ fontSize: 24 }} />,
        path: "/change-password",
        roles: null,
    },
    {
        id: "user-management",
        name: "User Management",
        icon: <People sx={{ fontSize: 24 }} />,
        path: "/user-management",
        roles: ["WB-ADMIN"],
    },
    {
        id: "platform-admin",
        name: "Platform Admin",
        icon: <AdminPanelSettings sx={{ fontSize: 24 }} />,
        path: "/admin/vspp/9403/ktl/dashboard",
        roleCheck: (roles) => roles.includes("ADMIN#VI295") || roles.includes(";ADMIN#VI295"),
    },
    {
        id: "whatsapp-admin",
        name: "WhatsApp Business Admin",
        icon: <AdminPanelSettings sx={{ fontSize: 24 }} />,
        path: "/whatsapp-business/admin",
        roleCheck: (roles) => roles.includes("ADMIN#VI295") || roles.includes(";ADMIN#VI295"),
    },
    {
        id: "logout",
        name: "Logout",
        icon: <Logout sx={{ fontSize: 24 }} />,
        action: "logout",
        roles: null,
    },
];

export const CHAT_WINDOW_PATH = "/whatsapp-business/chat-window";

/** Shown under Credits Information only for credit-wallet accounts. */
export const CREDIT_INFO_CHILDREN = [
    { path: "/credits-info", name: "Balance", icon: <AccountBalanceWallet fontSize="small" /> },
    { path: "/billing/ledger", name: "Ledger", icon: <ReceiptLong fontSize="small" />, requiresBillingAdmin: true },
    { path: "/billing/topups", name: "Top-ups", icon: <Payments fontSize="small" />, requiresBillingAdmin: true },
];

export const resolvePrimaryItem = (item, isCreditBased) => {
    if (!item) return null;
    if (item.id === "credits-info" && isCreditBased) {
        return { ...item, child: CREDIT_INFO_CHILDREN };
    }
    return item;
};
